import React, { useEffect, useRef } from "react";
import ApporteurAffairesHeader from "../Components/ApporteurAffaires/ApporteurAffairesHeader";
import ApporteurAffairesContent from "../Components/ApporteurAffaires/ApporteurAffairesContent";
import RightModal from "../Components/Modals/RightModal/RightModal";
import ViewScroller from "../Components/Common/ViewScroller/ViewScroller";
import { useDispatch } from "react-redux";
import { getAffiliates } from "../REDUX/actions/affiliate";

const ApporteurAffaires = () => {
  const dispatch = useDispatch();

  const abortControllerRef = useRef(null);

  useEffect(() => {
    abortControllerRef.current?.abort();
    abortControllerRef.current = new AbortController();
    dispatch(getAffiliates(abortControllerRef.current.signal));
    return () => {
      abortControllerRef.current?.abort();
    };
  }, [dispatch]);

  return (
    <ViewScroller>
      <div className="w100 d-flex flex-column gap-4 h-100">
        <ApporteurAffairesHeader />
        <ApporteurAffairesContent />
        <RightModal width={60} />
      </div>
    </ViewScroller>
  );
};

export default ApporteurAffaires;
